import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Box, Button } from '@mui/material';
import { collection, getDocs, doc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase'; // Import your Firebase config

const ALeaveManagement = () => {
  const [leaveData, setLeaveData] = useState([]);
  const [employeesData, setEmployeesData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch leave data and employee data from Firestore
    const fetchData = async () => {
      try {
        const leaveSnapshot = await getDocs(collection(db, 'employeeLeave'));
        const employeeSnapshot = await getDocs(collection(db, 'employees'));

        // Process leave data
        const leaveData = leaveSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

        // Process employee data
        const employeesData = employeeSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

        // Set state
        setLeaveData(leaveData);
        setEmployeesData(employeesData);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Match leave data with employee data
  const enrichedLeaveData = leaveData.map(leave => {
    const employee = employeesData.find(emp => emp.id === leave.employeeId);
    return {
      ...leave,
      employeeName: employee?.name || 'N/A',
      employeePosition: employee?.position || 'N/A',
    };
  });

  // Update leave status in Firestore
  const handleStatusChange = async (id, status) => {
    try {
      const leaveDoc = doc(db, 'employeeLeave', id);
      await updateDoc(leaveDoc, { status });
      setLeaveData(prevState =>
        prevState.map(leave =>
          leave.id === id ? { ...leave, status } : leave
        )
      );
    } catch (error) {
      console.error('Error updating leave status:', error);
    }
  };

  const getStatusStyle = (status) => {
    if (status === 'Approved') {
      return {
        backgroundColor: '#39B54A',
        color: 'white',
        padding: '5px 10px',
        borderRadius: '4px',
        textAlign: 'center',
      };
    } else if (status === 'Pending') {
      return {
        backgroundColor: '#FFA500',
        color: 'white',
        padding: '5px 10px',
        borderRadius: '4px',
        textAlign: 'center',
      };
    } else if (status === 'Disapproved') {
      return {
        backgroundColor: '#d32f2f',
        color: 'white',
        padding: '5px 10px',
        borderRadius: '4px',
        textAlign: 'center',
      };
    }
  };

  return (
    <Box sx={{ flexGrow: 1, padding: 3, paddingTop: 0, marginTop: 0 }}>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6" sx={{ color: '#39B54A' }}>
          Leave Management
        </Typography>
      </Box>
      <Box
        sx={{
          backgroundColor: 'white',
          borderRadius: 2,
          padding: 3,
          marginTop: 2,
        }}
      >
        {loading ? (
          <Typography>Loading leaves...</Typography>
        ) : (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell><strong>Employee ID</strong></TableCell>
                  <TableCell><strong>Employee Name</strong></TableCell>
                  <TableCell><strong>Employee Position</strong></TableCell>
                  <TableCell><strong>Leave Start Date</strong></TableCell>
                  <TableCell><strong>Leave End Date</strong></TableCell>
                  <TableCell><strong>Applied Leave Hours</strong></TableCell>
                  <TableCell><strong>Leave Status</strong></TableCell>
                  <TableCell><strong>Applied At</strong></TableCell>
                  <TableCell><strong>Actions</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {enrichedLeaveData.map((leave) => (
                  <TableRow key={leave.id}>
                    <TableCell>{leave.employeeId}</TableCell>
                    <TableCell>{leave.employeeName}</TableCell>
                    <TableCell>{leave.employeePosition}</TableCell>
                    <TableCell>{leave.startDate}</TableCell>
                    <TableCell>{leave.endDate}</TableCell>
                    <TableCell>{leave.totalHours}</TableCell>
                    <TableCell >
                     <Box sx={getStatusStyle(leave.status)}>
                        {leave.status}
                     </Box>
                    </TableCell>
                    <TableCell>{new Date(leave.timestamp).toLocaleString()}</TableCell>
                    <TableCell>
                      <Button
                        variant="contained" 
                        sx={{ backgroundColor: '#39B54A', '&:hover': { backgroundColor: '#2c8f39' }, ml:1, mb:1 }}
                        onClick={() => handleStatusChange(leave.id, 'Approved')}
                        
                      >
                        Approve
                      </Button>
                      <Button
                        variant="contained"
                        color="error"
                        onClick={() => handleStatusChange(leave.id, 'Disapproved')}
                      >
                        Disapprove
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    </Box>
  );
};

export default ALeaveManagement;
